import app from '@devices/settings/device_settings/app.js';
import device_information from '@devices/settings/device_settings/device_information';
import share from '@devices/settings/device_settings/share.js';

export default {
	name: 'ShellyBLUDWMiniZB',
	friendly_name: 'BLU Door Window Mini ZB',
	category: 'sensor',
	family: 'sensor',
	isPM: false,
	dashInfoLabels: 'sensor-dw',
	modes: {
		sensor: {
			availableViews: ['basic', 'advanced'],
			channels: 1,
			notifications: ['device_problem', 'lowBattery'],
			charts: false,
			dashInfoLabels: 'sensor-dw',
			bluetooth_settings: [
				{ title: 'beacon_mode', component: 'beacon_ble' },
				{ title: 'zigbee', component: 'zigbee_ble', min_ver: '1.2.12' },
				{ title: 'security', component: 'security_ble' },
			],
			settings: [
				app,
				share,
				{
					title: 'settings',
					components: [
						{
							title: 'angle_report_threshold',
							component: 'angle_report_threshold_ble',
							min_ver: '1.0.23',
						},
						{
							title: 'bright_threshold',
							component: 'bright_threshold_ble',
						},
						{
							title: 'dark_threshold',
							component: 'dark_threshold_ble',
						},
						{ title: 'firmware_version', component: 'firmware_update_ble' },
						{ title: 'factory_reset', component: 'factory_reset_ble' },
					],
				},
				device_information,
			],
		},
	},
};
